var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoProjipac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.333,
    height: 61.597,
    viewBox: "0 0 62.333 61.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-629 -157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.83,394.131l4.079-6.218v6.218Zm-4.553,2.536h8.586v3.59h2.826v-3.59h1.787v-2.536h-1.787V384.124h-3.147Z",
    transform: "translate(185.292 -188.259)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.9,321.738l-23.343,13.291v2.414h3.682v12.084s-5.377,1.36-8.6,3.621-1.222,4.828-1.222,4.828h61.414v-5.744s1.222-3.773-1.222-5.133a1.8,1.8,0,0,0-2.918,1.222,3.111,3.111,0,0,0-3.224-2.429c-1.879-.092-2.352.932-2.459,1.681v.749a2.548,2.548,0,0,1,0-.749V337.443h4.9v-2.414l-24.566-13.291h-1.222a17.211,17.211,0,0,0,0-6.035c-.611-3.025-1.7-5.744-7.364-7.241-5.683-1.512-11.672,5.133-14.742,4.828s-4.919-6.034-4.919-6.034-.764,2.857,3.682,7.241c4.461,4.369,17.049,3.315,18.424,2.414s0-2.719,2.459-2.414S430.9,321.738,430.9,321.738Zm-6.141,22.946c0-4.659,6.752-15.4,8.586-15.4.932,0,8.6,10.74,8.6,15.4a8.594,8.594,0,0,1-17.187,0Z",
    transform: "translate(228.202 -139.378)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.138,294.292s-2.154-8.906,6.142-10.877c8.28-1.956,15.812-.153,18.424-1.207s3.682-4.828,3.682-4.828-.611,16.3-9.67,21.144c-8.953,4.766-13.52,4.828-14.9,3.01s.917-5.439,2.46-7.241c1.528-1.818,3.987-3.468,1.222-3.621s-6.141,4.828-6.141,4.828Z",
    transform: "translate(169.642 -120.38)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoProjipac);
export default __webpack_public_path__ + "static/media/logo-projipac.45223c14699ff6dad22c532ffd5edc7f.svg";
export { ForwardRef as ReactComponent };